import LegalPage, { LSection, LList } from "../../components/legal/LegalPage";
import { LEGAL_IDENTITY } from "../../lib/legal";

export default function Terms() {
  return (
    <LegalPage
      title="Términos y condiciones de uso"
      subtitle="Condiciones aplicables al piloto B2B de Asset Passport. Estos términos están dirigidos únicamente a empresas y usuarios profesionales."
      testid="terms-page"
    >
      <LSection n="1" title="Partes y aceptación">
        <p>
          El servicio es prestado por {LEGAL_IDENTITY.ownerName} bajo el nombre comercial{" "}
          {LEGAL_IDENTITY.commercialName}.
        </p>
        <p>
          El cliente representa a una empresa o actúa en calidad profesional o empresarial. El
          servicio no está actualmente destinado a consumidores ni a uso doméstico privado.
        </p>
        <p>
          La aceptación de estos términos se produce durante la activación de la cuenta del
          administrador inicial.
        </p>
      </LSection>

      <LSection n="2" title="Piloto">
        <LList
          items={[
            "el acceso actual es un piloto B2B gratuito",
            "el acceso se realiza mediante invitación o aprobación",
            "la participación no garantiza disponibilidad permanente del servicio",
            "las funcionalidades del piloto pueden evolucionar",
            "pueden introducirse cambios razonables durante las pruebas",
            "Asset Passport puede finalizar el piloto con un preaviso razonable, cuando sea posible",
            "la participación en el piloto no crea automáticamente una futura suscripción de pago",
          ]}
        />
        <p>
          Si en el futuro se introducen planes de pago, el cliente será informado de los precios y
          condiciones aplicables antes de asumir obligación de pago alguna. No existirá conversión
          automática a un servicio de pago.
        </p>
      </LSection>

      <LSection n="3" title="Cuenta y organización">
        <p>
          Cada cliente recibe un entorno de organización propio. El administrador inicial es
          responsable de gestionar los usuarios de su empresa.
        </p>
        <p>Los usuarios deben:</p>
        <LList
          items={[
            "facilitar información veraz",
            "mantener la confidencialidad de sus credenciales",
            "utilizar cuentas individuales",
            "notificar a Asset Passport cualquier sospecha de acceso no autorizado",
            "no compartir cuentas de forma indebida",
          ]}
        />
      </LSection>

      <LSection n="4" title="Uso permitido">
        <p>
          Asset Passport puede utilizarse para organizar información de activos industriales,
          incluyendo:
        </p>
        <LList
          items={[
            "identificación",
            "documentación",
            "fotografías",
            "ubicaciones",
            "historial e intervenciones",
            "información relacionada con las máquinas",
          ]}
        />
      </LSection>

      <LSection n="5" title="Contenido del cliente">
        <p>
          El cliente conserva los derechos sobre el contenido que sube a Asset Passport y concede a
          Asset Passport únicamente los derechos técnicamente necesarios para alojar, tratar,
          reproducir y mostrar dicho contenido en la prestación del servicio.
        </p>
        <p>
          El cliente es responsable de garantizar que dispone de los derechos y la base jurídica
          necesarios para subir el contenido, y no debe subir contenido ilícito o que infrinja
          derechos de terceros.
        </p>
      </LSection>

      <LSection n="6" title="Datos personales">
        <p>
          Cuando Asset Passport trate datos personales contenidos en el contenido del cliente por
          cuenta de este, será de aplicación el Acuerdo de Encargo del Tratamiento (DPA).
        </p>
        <p>
          El cliente es responsable de determinar la base jurídica y de facilitar la información
          necesaria a su personal y demás interesados cuando sea preciso.
        </p>
      </LSection>

      <LSection n="7" title="Códigos QR">
        <p>
          Los códigos QR proporcionan una vía cómoda de acceso al pasaporte de la máquina
          correspondiente. Que un código QR sea físicamente visible no autoriza por sí mismo el
          acceso a la información protegida: el acceso permanece sujeto a los mecanismos de
          autenticación y autorización implementados por Asset Passport.
        </p>
        <p>
          Los clientes son responsables de la colocación y gestión adecuadas de las etiquetas QR
          físicas.
        </p>
      </LSection>

      <LSection n="8" title="Naturaleza del servicio">
        <p>
          Asset Passport es una plataforma de organización de información e identidad de activos.
          No es:
        </p>
        <LList
          items={[
            "software de control industrial",
            "software de seguridad de máquinas",
            "un sistema de emergencia",
            "un sustituto de un CMMS/GMAO",
            "un ERP",
            "un MES",
            "un sistema de certificación de fabricantes",
          ]}
        />
        <p>
          La información contenida en Asset Passport no debe sustituir las instrucciones del
          fabricante, las inspecciones obligatorias, la evaluación técnica profesional ni los
          requisitos de seguridad aplicables.
        </p>
      </LSection>

      <LSection n="9" title="Disponibilidad y limitaciones del piloto">
        <p>
          El servicio se presta con esfuerzos razonables para mantener su disponibilidad. No se
          garantiza disponibilidad ininterrumpida ni niveles de servicio específicos. Durante el
          piloto pueden producirse interrupciones temporales y cambios.
        </p>
      </LSection>

      <LSection n="10" title="Usos prohibidos">
        <p>Queda prohibido:</p>
        <LList
          items={[
            "utilizar el servicio con fines ilícitos",
            "intentar accesos no autorizados",
            "eludir los mecanismos de seguridad",
            "la ingeniería inversa, cuando legalmente sea posible prohibirla",
            "introducir software malicioso",
            "realizar peticiones automatizadas abusivas",
            "utilizar credenciales de otra empresa",
            "acceder a datos sin autorización",
            "subir contenido sin los derechos necesarios",
            "perturbar el funcionamiento de la plataforma",
          ]}
        />
      </LSection>

      <LSection n="11" title="Suspensión">
        <p>
          Asset Passport puede suspender el acceso cuando sea razonablemente necesario por:
          incidentes de seguridad, sospecha de acceso no autorizado, uso ilícito, incumplimiento
          material, riesgo para otros clientes o para la plataforma, u obligaciones legales. Cuando
          sea posible, se informará a los clientes afectados.
        </p>
      </LSection>

      <LSection n="12" title="Terminación">
        <p>
          El cliente puede solicitar la finalización de su participación en el piloto, y Asset
          Passport puede dar por finalizado el acceso al piloto con un preaviso razonable, cuando
          sea posible.
        </p>
        <p>
          Los datos de la aplicación se eliminarán o desactivarán conforme a los procedimientos de
          borrado vigentes y a las obligaciones legales aplicables. La eliminación física de los
          objetos de almacenamiento subyacentes puede depender de las capacidades del proveedor de
          almacenamiento.
        </p>
      </LSection>

      <LSection n="13" title="Propiedad intelectual">
        <p>
          Asset Passport conserva los derechos sobre el software, el diseño del producto, la marca,
          la interfaz, el código y la funcionalidad de la plataforma. El cliente conserva su propio
          contenido subido.
        </p>
        <p>
          Los comentarios y sugerencias podrán utilizarse para mejorar Asset Passport, sin que ello
          transfiera la propiedad de la información confidencial del cliente.
        </p>
      </LSection>

      <LSection n="14" title="Confidencialidad">
        <p>
          Ambas partes tratarán como confidencial la información empresarial, técnica y operativa no
          pública obtenida a través del piloto y la utilizarán únicamente para fines relacionados
          con el servicio, salvo que la ley exija su revelación.
        </p>
      </LSection>

      <LSection n="15" title="Responsabilidad">
        <p>
          Asset Passport no responde de decisiones técnicas o de mantenimiento adoptadas
          exclusivamente sobre la base de información introducida por el cliente, de contenido del
          cliente inexacto ni del uso indebido de la plataforma.
        </p>
        <p>
          La responsabilidad de Asset Passport se limitará en la medida permitida por la legislación
          aplicable, teniendo en cuenta la naturaleza gratuita del piloto. Nada de lo dispuesto en
          estos términos pretende excluir responsabilidad cuando dicha exclusión esté prohibida por
          ley.
        </p>
      </LSection>

      <LSection n="16" title="Cambios en los términos">
        <p>
          Los cambios materiales se comunicarán de forma apropiada. El uso continuado tras la
          entrada en vigor de los cambios podrá constituir aceptación cuando legalmente proceda,
          si bien los cambios significativos que afecten a derechos contractuales requerirán el
          preaviso o la aceptación que corresponda.
        </p>
      </LSection>

      <LSection n="17" title="Ley y jurisdicción">
        <p>
          Estos términos se rigen por la ley española. Para relaciones B2B, serán competentes, cuando
          legalmente sea posible, los juzgados y tribunales correspondientes al establecimiento del
          prestador.
        </p>
      </LSection>
    </LegalPage>
  );
}
